export default "__VITE_ASSET__DftJqiZY__"